import OrderedAmount from './OrderedAmount';
export default OrderedAmount;
